import { PrinterOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";

import { WarrantyInfoResponse } from "../../../../graphql/operations/@types";
import { useGetWarrantyInfoListQuery } from "../../../../graphql/operations/clubApp/warranty/get-warranty-info";
import { MarketType } from "../../../../types/types";
import WarrantyPrint from "./WarrantyPrint";

interface WarrantyPrintButtonProps {
  applicationIds: number[];
  buttonText: string;
  type: "primary" | "default";
  market: MarketType;
  disabled?: boolean;
}

const WarrantyPrintButton = ({
  applicationIds,
  buttonText,
  type,
  market,
  disabled = false
}: WarrantyPrintButtonProps) => {
  const printRef = useRef<HTMLDivElement>(null);
  const [warrantyInfoList, setWarrantyInfoList] = useState<WarrantyInfoResponse[]>([]);
  const [shouldPrint, setShouldPrint] = useState(false);

  const { refetch, loading } = useGetWarrantyInfoListQuery({
    variables: { applicationIds: applicationIds },
    skip: true
  });

  const handleClick = async () => {
    if (!applicationIds.length) return;

    try {
      const result = await refetch();
      if (result.data?.warrantyInfoList) {
        setWarrantyInfoList(result.data.warrantyInfoList);
        setShouldPrint(true);
      }
    } catch (error) {
      message.error("Print Failed");
    }
  };

  const handlePrint = useReactToPrint({
    contentRef: printRef,
  });

  useEffect(() => {
    if (shouldPrint && warrantyInfoList.length > 0) {
      handlePrint();
      setShouldPrint(false);
    }
  }, [shouldPrint, warrantyInfoList]);

  return (
    <>
      <Button
        onClick={handleClick}
        disabled={disabled}
        type={type}
        {...(type === "primary" ? { icon: <PrinterOutlined /> } : {})}
        loading={loading}
      >
        {buttonText}
      </Button>

      <div style={{ display: "none" }}>
        <div ref={printRef}>
          <WarrantyPrint
            warrantyInfoList={warrantyInfoList}
            market={market}
          />
        </div>
      </div>
    </>
  );
};

export default WarrantyPrintButton;